export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            被窝影院 — 让每一部好片都有温度
          </h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/80">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              被窝影院成立于对影视的热爱。我们相信最好的观影体验不是冰冷的放映厅，而是窝在被窝里、手边一杯热茶、眼前一部好片的温暖时刻。被窝影院官网致力于为所有影迷提供一个高清、免费、无广告干扰的在线观影平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              从热门院线大片到经典老剧，从国产高分剧到海外口碑佳作，我们的片库覆盖动作、喜剧、爱情、悬疑、科幻、动漫、纪录片等全类型。每日滚动更新，确保您总能看到最新、最热的影视内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              被窝影院最新地址首页直达，安全便捷。我们持续优化播放体验，追求高清画质与流畅播放的完美平衡，让每一次点击都成为一次愉悦的观影旅程。无论您是追剧达人还是偶尔放松，被窝影院都将是您最温暖的观影伙伴。
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
            {[
              { num: '5+', label: '运营年份' },
              { num: '20000+', label: '影视资源' },
              { num: '99.9%', label: '播放成功率' },
              { num: '100万+', label: '月活跃用户' },
            ].map((item, i) => (
              <div key={i} className="text-center p-4 bg-background-50 rounded-xl border border-background-200/70">
                <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">{item.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}